const _jsxFileName = '';
import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return React.createElement(
    'div',
    {
      className: `fixed bottom-8 right-8 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`,
      __self: this,
      __source: { fileName: _jsxFileName, lineNumber: 28 },
    },
    React.createElement(
      'button',
      {
        onClick: scrollToTop,
        className:
          'group flex items-center justify-center w-12 h-12 rounded-full bg-stone-900 text-gold-400 shadow-xl hover:bg-gold-600 hover:text-white transition-all duration-300 hover:-translate-y-1',
        'aria-label': 'Scroll to top',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 29 },
      },

      React.createElement(ArrowUp, {
        size: 20,
        className: 'group-hover:animate-bounce',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 34 },
      })
    )
  );
};

export default ScrollToTop;
